import { BaseSerializer } from "./baseSerializer.ts";
import {Employee} from "../employee.model.ts";
import {PersonSerializer} from "./personSerializer.ts";
import { OrganizationSerializer } from "./organizationSerializer.ts";

export class EmployeeSerializer extends BaseSerializer {
    public deserialize(data: Record<string, any>): Employee {
        const employee = new Employee();
        this._copyAttributes(employee, data);

        if (data.person) {
            const personSerializer = new PersonSerializer();
            employee.person = personSerializer.deserialize(data.person);
        }

        if (data.organization) {
            const organizationSerializer = new OrganizationSerializer();
            employee.organization = organizationSerializer.deserialize(data.organization)
        }

        return employee;
    }
}
